import React from 'react'
import { URL_SRV_RAIZ } from '../../router/Url'

const ObtenerUserByRut = async ({ACTION, DATA}) => {
  // console.log({ACTION, DATA})
  return new Promise(async (resolve, reject) => {
    let query = await fetch(URL_SRV_RAIZ+"crud_user_fractal",{
      method: 'POST',
      headers: {
        'authorization': "marcuxo",
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ACTION, DATA})
    })
    let responsito = await query.json();
    // console.log(responsito.body[0]);
    if(responsito.success){
      resolve(responsito.body)
    }else{
      console.log('ERROR REGISTRO');
      if(responsito.message === "500")resolve(alert('Error de servidor, Intentelo mas tarde'))
      if(responsito.message === "404")resolve(alert('Error de servidor, Intentelo mas tarde'))
    }
  })
}

export default ObtenerUserByRut